/**
 * @param {string} selector
 */
const removeWidthHeight = (selector) => {
  const elements = document.querySelectorAll(selector);

  elements.forEach((element) => {
    element.removeAttribute("width");
    element.removeAttribute("height");
    element.style.width = null;
    element.style.height = null;
  });
}

removeWidthHeight(".entry-content table");
removeWidthHeight(".entry-content tr");
removeWidthHeight(".entry-content th");
removeWidthHeight(".entry-content td");

